'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextFile = require('./TextFile');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextFile).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/TextFile/index.js
// module id = 1306
// module chunks = 1